
    var riot = require('riot')
    //src: starling/src/tags/menu/edit-share-user-access-menu.html
riot.tag2('edit-share-user-access-menu',
  '<ul class="floating-menu_list"> <li class="floating-menu_item {!isSelected(\'edit\') && \'floating-menu_item--iconless\'}" onclick="{handleClick.bind(this, \'edit\')}"> <svg if="{isSelected(\'edit\')}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label"> Can edit </span> </li> <li class="floating-menu_item {!isSelected(\'comment\') && \'floating-menu_item--iconless\'}" onclick="{handleClick.bind(this, \'comment\')}"> <svg if="{isSelected(\'comment\')}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label"> Can comment </span> </li> <li class="floating-menu_item {!isSelected(\'view\') && \'floating-menu_item--iconless\'}" onclick="{handleClick.bind(this, \'view\')}"> <svg if="{isSelected(\'view\')}" class="floating-menu_icon" style="color: #0077f1;"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label"> Can view </span> </li> <li class="floating-menu_divider"></li> <li class="floating-menu_item floating-menu_item--iconless" onclick="{handleClick.bind(this, \'removed\')}"> <span class="floating-menu_label">Remove</span> </li> </ul>',
  '',
  'show="{isOpen}" class="floating-menu floating-menu--small floating-menu--fixed"', function(opts) {
'use strict';

var _this = this;

var _menuUi = require('lib/menu-ui');

var root = this.root;
var _opts = opts,
    canvas = _opts.canvas;

canvas.editShareUserAccessMenu = this;

this.isOpen = false;
this.data = {};

this.summon = function (_ref) {
  var collab = _ref.collab,
      referenceEl = _ref.referenceEl;

  _this.isOpen = true;
  _this.collab = collab;

  _menuUi.mui.positionSelf({
    selfEl: root,
    referenceEl: referenceEl
  });

  _this.update();
};

this.hide = function () {
  _this.isOpen = false;
  _this.collab = null;
  _this.update();
};

this.isOpenForUser = function (collab) {
  if (!_this.isOpen) return false;
  if (!_this.collab) return false;
  if (_this.collab.userId && collab.userId && _this.collab.userId === collab.userId) return true;
  if (_this.collab.inviteId && collab.inviteId && _this.collab.inviteId === collab.inviteId) return true;
  return false;
};

this.isSelected = function (type) {
  if (_this.collab && _this.collab.permission === type) return true;
  return false;
};

this.handleClick = function (permission, e) {
  var collab = _this.collab;

  if (!collab) return;

  var userId = collab.userId,
      inviteId = collab.inviteId;

  collab.permission = permission;

  canvas.operation.updateUserShareSettings({
    sharedWithUserId: userId,
    inviteId: inviteId,
    permission: permission,
    onSuccess: function onSuccess() {
      canvas.inviteSharePanel.updateSharedWithUsers([{
        inviteId: inviteId,
        userId: userId,
        permission: permission
      }]);
      canvas.inviteSharePanel.update();
      _this.update();
    }
  });

  _this.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('edit-share-user-access-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/edit-share-user-access-menu.html
// module id = 677
// module chunks = 0